import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _camelCase from "lodash/camelCase";
import _upperFirst from "lodash/upperFirst";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useRef } from 'react';
import classnames from 'classnames';
import { Container } from "../../Container/Container/Container";
import { Icon } from "../../Icon/Icon/Icon";
import { Link } from "../../Button/Link/Link";
import { OfferBanner } from "../../Banner/OfferBanner/OfferBanner";
import { ScrollTracking } from "../../ScrollTracking/ScrollTracking";
import { Theme } from "../../Background/Theme/Theme";
import { Text } from "../../Text/Text/Text";
import styles from "./CalloutSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CalloutSlice = function CalloutSlice(_ref) {
  var _offerBanner$text, _offerBanner$popup;
  var _ref$background = _ref.background,
    background = _ref$background === void 0 ? 'none' : _ref$background,
    eyebrow = _ref.eyebrow,
    primary = _ref.primary,
    _ref$offerBanner = _ref.offerBanner,
    offerBanner = _ref$offerBanner === void 0 ? {} : _ref$offerBanner,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'darkBackground' : _ref$theme,
    _ref$align = _ref.align,
    align = _ref$align === void 0 ? 'left' : _ref$align,
    _ref$tall = _ref.tall,
    tall = _ref$tall === void 0 ? false : _ref$tall,
    _ref$sticky = _ref.sticky,
    sticky = _ref$sticky === void 0 ? false : _ref$sticky;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    stuck = _useState2[0],
    setStuck = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var calloutRef = useRef(null);
  var toggleSticky = function toggleSticky(stuck) {
    if (sticky) {
      // Set height so page doesn't bounce when element is sticky
      if (calloutRef) {
        var _calloutRef$current;
        var currentOffesetHeight = (_calloutRef$current = calloutRef.current) !== null && _calloutRef$current !== void 0 && _calloutRef$current.offsetHeight ? String(calloutRef.current.offsetHeight) : undefined;
        var newHeight = stuck ? currentOffesetHeight : '';
        setHeight(newHeight);
      }
      setStuck(stuck);
    }
  };
  var addLink = function addLink(url, newWindow, children, attributes) {
    return url ? /*#__PURE__*/_jsx(Link, {
      url: url,
      className: styles.link,
      attributes: attributes,
      newWindow: newWindow,
      children: children
    }) : children;
  };
  if (offerBanner) {
    offerBanner.sticky = stuck;
  }
  var hasOfferBanner = offerBanner && ((offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$text = offerBanner.text) === null || _offerBanner$text === void 0 ? void 0 : _offerBanner$text.text) || (offerBanner === null || offerBanner === void 0 ? void 0 : (_offerBanner$popup = offerBanner.popup) === null || _offerBanner$popup === void 0 ? void 0 : _offerBanner$popup.title));
  var backgroundStyle = background !== 'none' ? {
    backgroundColor: background,
    height: height
  } : {
    height: height
  };
  var offerBannerAlign = align;
  if (offerBannerAlign === 'left-center') {
    offerBannerAlign = 'left';
  } else if (offerBannerAlign === 'center-left') {
    offerBannerAlign = 'center';
  }
  return /*#__PURE__*/_jsx(Theme, {
    theme: theme,
    children: /*#__PURE__*/_jsx("div", {
      ref: calloutRef,
      children: /*#__PURE__*/_jsx(ScrollTracking, {
        onScrollUp: function onScrollUp() {
          return toggleSticky(false);
        },
        onScrollDown: function onScrollDown() {
          return toggleSticky(true);
        },
        onHide: function onHide() {
          return toggleSticky(true);
        },
        onShow: function onShow() {
          return toggleSticky(false);
        },
        children: /*#__PURE__*/_jsx("div", {
          className: classnames(styles.callout, {
            [styles.tall]: tall
          }),
          "data-e2e-name": "callout_slice",
          style: backgroundStyle,
          children: /*#__PURE__*/_jsx("div", {
            className: classnames({
              [styles.sticky]: stuck
            }),
            children: /*#__PURE__*/_jsx(Container, {
              innerClassName: styles.inner,
              children: /*#__PURE__*/_jsxs("div", {
                className: styles["wrapper".concat(_upperFirst(_camelCase(align)))],
                children: [(eyebrow === null || eyebrow === void 0 ? void 0 : eyebrow.text) && /*#__PURE__*/_jsx(Text, {
                  className: styles.eyebrow,
                  typog: eyebrow.typog,
                  children: eyebrow.text
                }), (primary === null || primary === void 0 ? void 0 : primary.text) && addLink(primary.url, primary.newWindow, /*#__PURE__*/_jsxs(Text, {
                  className: styles.primary,
                  typog: primary.typog,
                  childrenInline: true,
                  children: [/*#__PURE__*/_jsxs("span", {
                    className: styles.primaryWrapper,
                    children: [/*#__PURE__*/_jsx("span", {
                      className: styles.primaryText,
                      children: primary.text
                    }), primary.stickyText && /*#__PURE__*/_jsx("span", {
                      className: styles.primarySticky,
                      children: primary.stickyText
                    })]
                  }), primary.url && /*#__PURE__*/_jsx(Icon, {
                    className: styles.primaryIcon,
                    fill: "CurrentColor",
                    type: "primary-link"
                  })]
                }), primary.attributes), hasOfferBanner && /*#__PURE__*/_jsx(OfferBanner, _objectSpread({
                  align: offerBannerAlign,
                  wrapperClassName: styles.offerWrapper
                }, offerBanner))]
              })
            })
          })
        })
      })
    })
  });
};